import React, { useState, useEffect, PureComponent } from "react";
import "./css/SCPChart.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Brush,
} from "recharts";
import "./css/AiTable.css";
import { Table } from "./SCPTable";
import { Styles, color } from "./SCPChartHelpers";
import { LineCustomTooltip } from "./CustomToolTip";

const SCPDefaultChart = ({ jsonData, title }) => {
  let chartType = document.getElementById("type").textContent;

  const COLUMNS = JSON.parse(document.getElementById("COLUMNS").textContent);

  const [inputData, setInputData] = useState([]);

  const getLineChart = () => {
    const keysArr = Object.keys(jsonData[0]).slice(1);
    const lineArr = [];
    keysArr.forEach((item, index) => {
      lineArr.push(<Line type="linear" dataKey={item} stroke={color[index]} />);
    });
    return lineArr;
  };

  //const [pivotData, setPivotData] = useState(null);
  //<Tooltip formatter={ModifyFormatter} itemSorter={handleSort} /> - old tooltip
  useEffect(() => {
    const jsonString = document.getElementById("inputData").textContent;
    if (jsonString) {
      const values = new Set();
      jsonData.forEach((item) => {
        values.add(item);
      });
      setInputData(Array.from(values));
      setInputData(jsonData);
    }
  }, []);

  if (chartType.includes("chart")) {
    return (
      <div>
        <div className="chartTitle">{title}</div>
        <LineChart
          width={1500}
          height={400}
          data={jsonData}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value) => value.slice(0, 3)}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis
            className="AxisLabels"
            dataKey={Object.keys(jsonData[0])[0]}
            angle={-30}
            height={80}
            minTickGap={30}
            textAnchor="end"
          />
          <YAxis className="AxisLabels" />
          <Legend className="Legend" />
          <Tooltip
            content={
              <LineCustomTooltip active={false} payload={[]} label={""} />
            }
          />

          {getLineChart()}
          <Brush dataKey={Object.keys(jsonData[0])[0]}>
            <LineChart>{getLineChart()}</LineChart>
          </Brush>
        </LineChart>
        <br />
        <Styles>
          <Table columns={COLUMNS} data={jsonData} />
        </Styles>
      </div>
    );
  } else {
    return (
      <div>
        <div className="chartTitle">{title}</div>
        <LineChart
          width={1500}
          height={400}
          data={jsonData}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value) => value.slice(0, 3)}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis
            className="AxisLabels"
            dataKey={Object.keys(jsonData[0])[0]}
            angle={-30}
            height={80}
            minTickGap={30}
            textAnchor="end"
          />
          <YAxis className="AxisLabels" />
          <Legend className="Legend" />
          <Tooltip
            content={
              <LineCustomTooltip active={false} payload={[]} label={""} />
            }
          />

          {getLineChart()}
          <Brush dataKey={Object.keys(jsonData[0])[0]}>
            <LineChart>{getLineChart()}</LineChart>
          </Brush>
        </LineChart>
        <br />
        <Styles>
          <Table columns={COLUMNS} data={jsonData} />
        </Styles>
      </div>
    );
  }
};

export default SCPDefaultChart;
